const LogisticsMapLocations = {
    init: function () {
        const mapWrapper = document.querySelector('.locations-map__map');
        const locations = [...document.querySelectorAll('.locations-map__addresses__location')];
        let map;

        function initMap() {
            map = new google.maps.Map((mapWrapper));

            setLocationPins(locations);
        }

        function addressString({street, housenumber, postcode, city, country}) {
            return street + ' ' + housenumber + ' ' + postcode + ' ' + city + ' ' + country;
        }

        function getLatLng(address, geocoder, location) {
            return new Promise(function (resolve, reject) {
                geocoder.geocode({'address': address}, function (results, status) {
                    if (status === 'OK') {
                        resolve(
                            {results, location});
                    } else {
                        reject(new Error('Couldnt\'t find the location'));
                    }
                })
            })
        }

        function setLocationPins(locations) {
            const geocoder = new google.maps.Geocoder();
            var bounds = new google.maps.LatLngBounds();

            if (locations.length) {
                const allLocs = locations.map(location => ({
                    title: location.querySelector(".locations-map__addresses__location__title").innerText,
                    street: location.querySelector(".locations-map__addresses__location__street").innerText,
                    houseNumber: location.querySelector(".locations-map__addresses__location__housenumber").innerText,
                    postcode: location.querySelector(".locations-map__addresses__location__postcode").innerText,
                    city: location.querySelector(".locations-map__addresses__location__city").innerText,
                    country: location.querySelector(".locations-map__addresses__location__country").innerText,
                    telephone: location.querySelector(".locations-map__addresses__location__telephone").innerText,
                    fax: location.querySelector(".locations-map__addresses__location__fax").innerText,
                    email: location.querySelector(".locations-map__addresses__location__email").innerText,
                    website: location.querySelector(".locations-map__addresses__location__website").innerText,
                }))
                    .map(item => ({...item, id: `${item.street}-${item.houseNumber}-${item.postcode}`}))
                    .reduce((acc, cur) => {
                        if (acc.some(item => item.id === cur.id)) {
                            return acc.map(item => {
                                if (item.id === cur.id) {
                                    return {
                                        ...item,
                                        count: item.count + 1,
                                        locationObjects: [...item.locationObjects, cur]
                                    }
                                }
                                return item;
                            })
                        } else {
                            return [...acc, {
                                id: cur.id,
                                addressString: addressString(cur),
                                count: 1,
                                locationObjects: [cur],
                            }];
                        }
                    }, []);

                Promise.all(
                    allLocs.map(location => getLatLng(location.addressString, geocoder, location))
                ).then((data) => {
                    data.forEach(({results, location}) => {
                        const firstLocDom = location.locationObjects[0];
                        map.setCenter(results[0].geometry.location);
                        const marker = new google.maps.Marker({
                            map: map,
                            position: new google.maps.LatLng(
                                results[0].geometry.location.lat(),
                                results[0].geometry.location.lng()
                            ),
                            icon: '/build/img/svg/map-pin-logistics.svg',
                        });

                        bounds.extend(marker.position);

                        const infoWindow = new google.maps.InfoWindow({
                            content: setInfoWindowContent(location.locationObjects),
                            ariaLabel: firstLocDom.title,
                            shouldFocus: true,
                            pixelOffset: new google.maps.Size(125, 245),
                        });

                        marker.addListener("click", () => {
                            infoWindow.open({
                                anchor: marker,
                                map,
                            });
                        });
                    });

                    map.fitBounds(bounds);
                }).catch((err) => {
                    console.error(err);
                });
            }
        }

        function setInfoWindowContent(locations) {
            const divs = locations.map(({ title,
                street,
                houseNumber,
                postcode,
                city,
                phone,
                fax,
                email,
                website}) => `<div class="locations-map__map__info-window">
                    <h3 class="locations-map__map__info-window__title">${title}</h3>
                    <div class="locations-map__map__info-window__content">
                        <p>
                            <span>${street !== undefined ? street : ''} ${houseNumber !== undefined ? houseNumber : ''}</span>
                            <span>${postcode !== undefined ? postcode : ''} ${city !== undefined ? city : ''}</span>
                            ${phone !== undefined ? `<span>${phone}</span>` : ''}
                            ${fax !== undefined ? `<span>${fax}</span>` : ''}
                        </p>
                        <p>
                            ${email !== undefined ? `<span><a href="mailto:${email}">${email}</a></span>` : ''}
                            ${website !== undefined ? `<span><a href="${website}">${website}</a></span>` : ''}
                        </p>
                    </div>
                </div>`);
            return divs.join('');
        }

        if (mapWrapper) {
            window.initMap = initMap;
        }
    }
}

export default LogisticsMapLocations;
